module.exports = __webpack_public_path__ + "img/success.d63cd69f.svg";